import React, { useEffect } from "react";
import { useDrawer } from "./DrawerStateProvider";
import { triggerTopGoAwayButton } from "../Input/GoAwayButton";
import { useModalState } from "../Modal/ModalStateProvider";

export enum DrawerSlideEnum {
	Right = "right",
	Left = "left"
}
interface DrawerProps {
	children: React.ReactNode;
	position?: DrawerSlideEnum;
	className?: string;
}

const Drawer: React.FC<DrawerProps> = ({
	children,
	position = DrawerSlideEnum.Right,
	className = ""
}) => {
	const { trayVisible, isAnimating } = useDrawer();
	const { modalVisible } = useModalState();
	const trayRef = React.useRef<HTMLDivElement>(null);

	// Handle outside clicks (scrim clicks)
	// Skip when a modal is open — the modal has its own outside-click handler
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (modalVisible) return;
			if (trayRef.current && !trayRef.current.contains(event.target as Node)) {
				// Use LIFO stack to trigger the topmost GoAwayButton
				triggerTopGoAwayButton();
			}
		};

		if (trayVisible) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [trayVisible, modalVisible]);

	if (!(trayVisible || isAnimating)) return null;

	return (
		<>
			{/* Scrim/Overlay */}
			<div
				className={`fixed inset-0 bg-primary-scrim z-drawer transition-opacity duration-300 ${isAnimating ? "opacity-70" : "opacity-0"}`}
			/>

			{/* Tray */}
			<div
				ref={trayRef}
				className={`fixed top-0 bottom-0 z-drawer shadow-lg flex flex-col bg-primary-background transition-transform duration-300 ease-in-out ${
					position === DrawerSlideEnum.Left ? "left-0" : "right-0"
				} ${
					isAnimating
						? "transform-none"
						: position === DrawerSlideEnum.Left
							? "-translate-x-full"
							: "translate-x-full"
				} ${className}
          ${window.innerWidth < 500 ? "w-full" : "max-w-[500 px]"}
        `}
			>
				{children}
			</div>
		</>
	);
};

export default Drawer;
